/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : Docs.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import customConsole from "../../config/customConsole";
import CommonBreadcrumbs from "../../components/customComponentsV2/common/Breadcrumbs/CommonBreadcrumbs";
import CustomSelectV2 from "../../components/customComponentsV2/common/select/CustomSelectV2";
function Docs() {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const jwtToken =
    localStorage.getItem("token") && localStorage.getItem("token").length
      ? localStorage.getItem("token")
      : sessionStorage.getItem("token") &&
        sessionStorage.getItem("token").length
        ? sessionStorage.getItem("token")
        : "";

  const microServices = [
    {
      name: "UCM",
      description: "User Configuration management",
      url: `${BASE_URL}/UCM/docs/json`,
    },
    {
      name: "SCM",
      description: "Settings Configuration Management",
      url: `${BASE_URL}/SCM/docs/json`,
    },
    {
      name: "PCM",
      description: "Project Configuration Management",
      url: `${BASE_URL}/PCM/docs/json`,
    },
    {
      name: "VLC",
      description: "Virtual Lab car Configuration",
      url: `${BASE_URL}/VLC/docs/json`,
    },
    {
      name: "ACM",
      description: "Approval Configuration Management",
      url: `${BASE_URL}/ACM/docs/json`,
    },
    {
      name: "TCM",
      description: "Test case Configuration Management",
      url: `${BASE_URL}/TCM/docs/json`,
    },
    {
      name: "LCM",
      description: "Legal Configuration Management",
      url: `${BASE_URL}/LCM/docs/json`,
    },
    {
      name: "REM",
      description: "Rule Engine Management",
      url: `${BASE_URL}/REM/docs/json`,
    },
    {
      name: "ICM",
      description: "Integration Configuration Management",
      url: `${BASE_URL}/ICM/docs/json`,
    },
    {
      name: "FSM",
      description: "File System Management",
      url: `${BASE_URL}/FSM/docs/json`,
    },
    {
      name: "NSM",
      description: "Notification Service Management",
      url: `${BASE_URL}/NSM/docs/json`,
    },
    {
      name: "RCS",
      description: "Recreation Service",
      url: `${BASE_URL}/RCS/docs/json`,
    },
  ];
  const [tabValue, setTabValue] = useState("UCM");
  const [selectedMiscroservice, setSelectedMiscroservice] = useState(
    microServices[0],
  );

  // Create options list for CustomSelectV2
  const optionsList = microServices.map((service) => ({
    value: service.name,
    label: service.name,
  }));

  //Function to update on change of the dropdown value
  const handleChange = (event) => {
    const newValue = event.target.value;
    setTabValue(newValue);
    customConsole(microServices.filter((data) => data.name === newValue));
    const data = microServices.filter((data) => data.name === newValue);
    if (data && data.length) {
      setSelectedMiscroservice(data[0]);
    }
  };

  const breadcrumbItems = [{ label: "Settings" }, { label: "API Document" }];

  return (
    <Box sx={styles.mainBox}>
      <Box sx={{ width: "100%", textAlign: "left", ml: 2, mt: 1, mb: 2 }}>
        <CommonBreadcrumbs items={breadcrumbItems} />
      </Box>
      <Box sx={{ width: "120px" }}>
        <CustomSelectV2
          required={false}
          label="Select service"
          // variant="outlined"
          // size="small"
          optionsList={optionsList}
          selectedValue={tabValue}
          handleOnChange={handleChange}
        />
      </Box>
      {/* Swagger Data to be shown here */}
      <Box sx={styles.swaggerData}>
        {jwtToken &&
          jwtToken.length &&
          selectedMiscroservice.url &&
          selectedMiscroservice.url.length ? (
          <SwaggerUI
            url={selectedMiscroservice.url}
            requestInterceptor={(req) => {
              req.headers.Authorization = `Bearer ${jwtToken}`;
              return req;
            }}
          />
        ) : (
          <Typography sx={styles.dataNotFound}>Data not found!</Typography>
        )}
      </Box>
    </Box>
  );
}

export default Docs;
const styles = {
  dataNotFound: {
    fontSize: "12px",
    fontWeight: "bold",
    color: "red",
    marginTop: "20px",
  },
  swaggerData: {
    minHeight: "20vH",
    width: "calc(100% - 20px)",
    maxWidth: "100%",
    margin: "10px",
    border: "1px solid black",
    borderRadius: "10px",
    paddingBottom: "10px",
    height: "80vh",
    overflow: "auto",
    boxSizing: "border-box",
  },
  mainBox: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
};
